module.exports = __webpack_public_path__ + "static/media/yammer.fcb27435.svg";